import { createStore } from "vuex";
/**
 * @deprecated
 * Vuex store is deprecated
 *
 * If you want to use it as a network layer (for caching and status tracking etc.), prefer using Vue-Query.
 *
 * If you want to use it as a global store, prefer using the Pinia store.
 */
export const store = createStore({});
